import { api } from '../index.js'
import serializer from '../../components/LayoutEditor/serializer'

export default {
  namespaced: true,

  state: {
    stages: [],
    stage: {},
    stageHasChanges: false,
    testEmailTo: 'izamojc@zamtools.com'
  },

  mutations: {
    updateStages(state, stages) {
      state.stages = stages
    },

    updateStage(state, stage) {
      state.stage = stage
    },

    deleteStage(state, stageId) {
      let i = state.stages.findIndex(stage => stage._id === stageId)
      state.stages.splice(i, 1)
    },

    updateAttribute(state, { attribute, value }) {
      state.stage[attribute] = value
    },

    updateStageHasChanges(state, value) {
      state.stageHasChanges = value
    },

    updateTestEmailTo(state, toAddress) {
      state.testEmailTo = toAddress
    }
  },

  actions: {
    async fetchAll({ commit, state }, campaignId) {
      let [stages] = await api.stages.all(campaignId)
      commit('updateStages', stages)
    },

    async fetchOne({ commit, state }, stageId) {
      let [stage] = await api.stages.one(stageId)
      stage.template_document = serializer.revive(stage.template_document)
      commit('updateStage', stage)
    },

    async saveStage({ commit, state }) {
      if(state.stage.rawMode)
        state.stage.rawModeContent = state.stage.template_html
      let [stage] = await api.stages.save(state.stage)
      stage.template_document = serializer.revive(stage.template_document)
      commit('updateStage', stage)
      return stage
    },

    newStage({ commit, state }, campaignId) {
      const stage = {
        name: '',
        campaign_id: campaignId,
        frequency: 1,
        limit: 10000,
        email_id: '',
        send_after_stage: null,
        days_after_stage: 0,
        description: '',
        email_subject: '',
        sender_name: '',
        sender_email: '',
        send_days_of_week: 'mon,tues,wed,thurs,fri,sat,sun',
        // send_time_from: 540, // 9AM in minutes since midnight
        send_time_from: 0, // 00:00 midnight
        // send_time_to: 1200, // 8PM in minutes since midnight
        send_time_to: 1439, // 23:59 One minute before midnight
        template_document: null,
        template_html: '',
        template_id: '',
        rawMode: false,
        rawModeContent: ''
      }

      commit('updateStage', stage)
    },

    updateStage({ commit, state }, stage) {
      commit('updateStage', stage)
    },

    updateAttribute({ commit, state }, { attribute, value }) {
      commit('updateAttribute', { attribute, value })
    },

    async deleteStage({ commit, state }, stageId) {
      await api.stages.delete(stageId)
      commit('deleteStage', stageId)
    },

    updateTestEmailTo({ commit, state }, value) {
      commit('updateTestEmailTo', value)
    },

    sendStageByEmail({ commit, state }, { stageId, subjectOverride, bodyOverride, resourceType, resourceId }) {
      api.stages.sendEmail(stageId, subjectOverride, bodyOverride, resourceType, resourceId)
    },

    updateStageHasChanges({ commit, state }, value) {
      commit('updateStageHasChanges', value)
    },

    async moveStageUp({ commit, state }, stageId) {
      let stage = state.stages.find(stage => stage._id === stageId)
      if (stage.send_after_stage !== null) {
        let previousStage = state.stages.find(inner => inner._id === stage.send_after_stage)
        let [sortedStages] = await api.stages.move(stageId, previousStage.send_after_stage)
        commit('updateStages', sortedStages)
      }
    },

    async moveStageDown({ commit, state }, stageId) {
      let nextStage = state.stages.find(stage => stage.send_after_stage === stageId)
      if (nextStage) {
        let [sortedStages] = await api.stages.move(stageId, nextStage._id)
        commit('updateStages', sortedStages)
      }
    }
  }
}
